import React, { useState, useRef, useEffect } from 'react';
import * as LuIcons from 'react-icons/lu';
import SafeIcon from '../common/SafeIcon';

const { LuShare2, LuCopy, LuCheck, LuX } = LuIcons;

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.118 1.528 5.845L.057 23.885l6.196-1.448A11.934 11.934 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.894a9.872 9.872 0 01-5.031-1.378l-.361-.214-3.741.981.999-3.648-.235-.374A9.867 9.867 0 012.106 12C2.106 6.58 6.58 2.106 12 2.106S21.894 6.58 21.894 12 17.42 21.894 12 21.894z" />
  </svg>
);

const TelegramIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

// باستخدام BrowserRouter لا نحتاج لـ #/
const getCarUrl = (carId) => `${window.location.origin}/car/${carId}`;

const ShareMenu = ({ car }) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const ref = useRef(null);

  const shareUrl = getCarUrl(car.id);
  const totalPrice = Number(car.total_price) > 0 ? Number(car.total_price) : ((Number(car.price) || 0) + (Number(car.customs_price) || 0) + (Number(car.shipping_price) || 0));
  const shareTitle = `${car.brand} ${car.model} موديل ${car.year} - ${totalPrice.toLocaleString()} دج`;
  const shareText = `🚗 ${shareTitle}\n📍 أوتو دي زد\n${shareUrl}`;

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    setOpen(false);
  };

  const SHARE_OPTIONS = [
    {
      id: 'whatsapp',
      label: 'واتساب',
      color: 'bg-green-500 hover:bg-green-600',
      Icon: WhatsAppIcon,
      getUrl: () => `https://wa.me/?text=${encodeURIComponent(shareText)}`,
    },
    {
      id: 'telegram',
      label: 'تيليغرام',
      color: 'bg-sky-500 hover:bg-sky-600',
      Icon: TelegramIcon,
      getUrl: () => `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(`🚗 ${shareTitle}`)}`,
    },
    {
      id: 'facebook',
      label: 'فيسبوك',
      color: 'bg-blue-600 hover:bg-blue-700',
      Icon: FacebookIcon,
      getUrl: () => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
    },
  ];

  return (
    <div className="relative w-full" ref={ref}>
      <button 
        onClick={() => setOpen(o => !o)} 
        className="flex items-center justify-center gap-1.5 px-3 py-2.5 border-2 border-slate-200 dark:border-slate-700 hover:border-emerald-400 dark:hover:border-emerald-500 hover:bg-emerald-50 dark:hover:bg-emerald-900/30 text-slate-600 dark:text-slate-300 hover:text-emerald-700 dark:hover:text-emerald-400 rounded-xl transition-colors text-sm font-bold w-full"
        title="مشاركة"
      >
        <SafeIcon icon={LuShare2} className="w-4 h-4" />
        مشاركة
      </button>

      {open && (
        <div className="absolute bottom-full mb-2 right-0 bg-white dark:bg-slate-800 rounded-2xl shadow-xl border border-slate-100 dark:border-slate-700 p-3 w-52 z-50">
          <div className="flex justify-between items-center mb-2 pb-2 border-b border-slate-100 dark:border-slate-700">
            <span className="text-xs font-bold text-slate-600 dark:text-slate-300">مشاركة عبر</span>
            <button onClick={() => setOpen(false)} className="text-slate-400 hover:text-slate-600 dark:hover:text-white">
              <SafeIcon icon={LuX} className="w-3.5 h-3.5" />
            </button>
          </div>
          <div className="space-y-1.5">
            {SHARE_OPTIONS.map(opt => (
              <a 
                key={opt.id} 
                href={opt.getUrl()} 
                target="_blank" 
                rel="noreferrer"
                onClick={() => setOpen(false)}
                className={`flex items-center gap-2.5 w-full px-3 py-2 rounded-xl text-white text-sm font-medium transition-colors ${opt.color}`}
              >
                <opt.Icon />
                {opt.label}
              </a>
            ))}
            <button 
              onClick={handleCopyLink}
              className="flex items-center gap-2.5 w-full px-3 py-2 rounded-xl bg-slate-100 dark:bg-slate-700 hover:bg-slate-200 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 text-sm font-medium transition-colors"
            >
              <SafeIcon icon={copied ? LuCheck : LuCopy} className="w-4 h-4" />
              {copied ? 'تم النسخ!' : 'نسخ رابط السيارة'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShareMenu;